export default __webpack_public_path__ + "static/media/piper-fence-crop.24e77bda.jpg";